import { render, staticRenderFns } from "./cv-accordion.vue?vue&type=template&id=b66f743e&"
import script from "./cv-accordion.vue?vue&type=script&lang=js&"
export * from "./cv-accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports